<div class="rounded-lg border border-e9e9e9 px-4 py-2 bg-white">
  <div class="flex items-center justify-between gap-2">
    <p class="text-sm sm:text-base xl:text-lg font-semibold text-black">Opening Balance</p>
    <p class="text-sm sm:text-base xl:text-lg font-semibold text-black">₹ {{ openingBalance | number:'1.2-2' }}</p>
  </div>
  <div class="mt-2 overflow-x-auto w-full">
    <table class="daybook-table w-full overflow-hidden">
      <thead class="text-[13px] sm:text-sm lg:text-[15px] font-semibold">
        <tr class="text-left bg-f9f9fb">
          <th>INV NO.</th>
          <th>DATE</th>
          <th>FIRM</th>
          <th class="whitespace-nowrap">USER NAME</th>
          <th>CITY</th>
          <th class="text-right">CASH</th>
          <th class="text-right" *ngIf="isGst">BANK</th>
          <th class="text-right" *ngIf="isGst">CARD</th>
          <th class="text-right" *ngIf="isGst">ONLINE</th>
          <th class="text-right">DISC</th>
          <th class="text-right">TOTAL</th>
        </tr>
      </thead>
      <tbody class="text-[13px] sm:text-sm lg:text-[15px] font-medium">
        <tr *ngFor="let item of transactions" class="border-b border-e9e9e9 last:border-0 hover:bg-f9f9fb">
          <td class="text-1c1c1c">{{item.invoice_no}}</td>
          <td class="text-1c1c1c whitespace-nowrap">{{item.date | date:'dd MMM yyyy'}}</td>
          <td class="text-1c1c1c">{{item.firm}}</td>
          <td class="text-c19725 whitespace-nowrap">{{item.user}}</td>
          <td class="text-1c1c1c">{{item.city}}</td>
          <td class="text-right" [ngClass]="item.cash >= 0 ? 'text-018f37' : 'text-bb0000'">{{item.cash |
            number:'1.2-2'}}</td>
          <td class="text-right" *ngIf="isGst" [ngClass]="item.bank >= 0 ? 'text-018f37' : 'text-bb0000'">{{item.bank |
            number:'1.2-2'}}</td>
          <td class="text-right" *ngIf="isGst" [ngClass]="item.card >= 0 ? 'text-018f37' : 'text-bb0000'">{{item.card |
            number:'1.2-2'}}</td>
          <td class="text-right" *ngIf="isGst" [ngClass]="item.online >= 0 ? 'text-018f37' : 'text-bb0000'">
            {{item.online |
            number:'1.2-2'}}</td>
          <td class="text-right" [ngClass]="item.disc >= 0 ? 'text-018f37' : 'text-bb0000'">{{item.disc |
            number:'1.2-2'}}</td>
          <td class="text-right font-bold" [ngClass]="item.total >= 0 ? 'text-018f37' : 'text-bb0000'">{{item.total |
            number:'1.2-2'}}</td>
        </tr>
        <tr *ngIf="transactions.length === 0">
          <td [attr.colspan]="isGst ? 11 : 8" class="text-center py-8 text-gray-400 italic">No transactions found for
            this period.</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-2 overflow-x-auto w-full">
    <table class="daybook-table w-full overflow-hidden">
      <thead class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
        <tr class="bg-f9f9fb">
          <th class="text-left capitalize text-sm sm:text-base xl:text-base">Transactional Details</th>
          <th [attr.colspan]="isGst ? 4 : 1"></th>
          <th class="text-bb0000 whitespace-nowrap">AMOUNT CR</th>
          <th></th>
          <th class="text-018f37 whitespace-nowrap">AMOUNT DR</th>
        </tr>
        <tr class="bg-f9f9fb">
          <th></th>
          <th>CASH</th>
          <th *ngIf="isGst">BANK</th>
          <th *ngIf="isGst">CARD</th>
          <th *ngIf="isGst">ONLINE</th>
          <th>DISC</th>
          <th class="whitespace-nowrap">EXTRA AMT.</th>
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-medium">
        <tr>
          <td class="text-018f37 whitespace-nowrap">AMOUNT IN :</td>
          <td class="text-018f37">{{ summary.amount_in.cash | number:'1.2-2' }}</td>
          <td class="text-018f37" *ngIf="isGst">{{ summary.amount_in.bank | number:'1.2-2' }}</td>
          <td class="text-018f37" *ngIf="isGst">{{ summary.amount_in.card | number:'1.2-2' }}</td>
          <td class="text-018f37" *ngIf="isGst">{{ summary.amount_in.online | number:'1.2-2' }}</td>
          <td class="text-018f37">{{ summary.amount_in.disc | number:'1.2-2' }}</td>
          <td class="text-bb0000">0.00</td>
          <td class="text-018f37">{{ summary.amount_in.total | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="text-bb0000 whitespace-nowrap">AMOUNT OUT :</td>
          <td class="text-bb0000">{{ summary.amount_out.cash | number:'1.2-2' }}</td>
          <td class="text-bb0000" *ngIf="isGst">{{ summary.amount_out.bank | number:'1.2-2' }}</td>
          <td class="text-bb0000" *ngIf="isGst">{{ summary.amount_out.card | number:'1.2-2' }}</td>
          <td class="text-bb0000" *ngIf="isGst">{{ summary.amount_out.online | number:'1.2-2' }}</td>
          <td class="text-bb0000">{{ summary.amount_out.disc | number:'1.2-2' }}</td>
          <td class="text-bb0000">0.00</td>
          <td class="text-bb0000">{{ summary.amount_out.total | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="text-bb0000 whitespace-nowrap">TODAY TOTAL :</td>
          <td class="text-bb0000">{{ (summary.amount_in.cash - summary.amount_out.cash) | number:'1.2-2' }}</td>
          <td class="text-bb0000" *ngIf="isGst">{{ (summary.amount_in.bank - summary.amount_out.bank) | number:'1.2-2'
            }}</td>
          <td class="text-bb0000" *ngIf="isGst">{{ (summary.amount_in.card - summary.amount_out.card) | number:'1.2-2'
            }}</td>
          <td class="text-bb0000" *ngIf="isGst">{{ (summary.amount_in.online - summary.amount_out.online) |
            number:'1.2-2' }}</td>
          <td class="text-bb0000">{{ (summary.amount_in.disc - summary.amount_out.disc) | number:'1.2-2' }}</td>
          <td class="text-bb0000">0.00</td>
          <td class="text-bb0000">{{ (summary.amount_in.total - summary.amount_out.total) | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="text-554646 whitespace-nowrap">OPENING BALANCE :</td>
          <td [attr.colspan]="isGst ? 6 : 3"></td>
          <td class="text-bb0000">{{ openingBalance | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="text-554646 whitespace-nowrap uppercase italic font-medium">Net Movement :</td>
          <td [attr.colspan]="isGst ? 6 : 3"></td>
          <td class="text-bb0000">{{ (summary.amount_in.total - summary.amount_out.total) | number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td class="text-554646 whitespace-nowrap font-bold">CLOSING AMOUNT :</td>
          <td [attr.colspan]="isGst ? 6 : 3"></td>
          <td class="text-554646 font-bold">{{ summary.closing_balance | number:'1.2-2' }}</td>
        </tr>
      </tbody>
      <tfoot class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
        <tr class="bg-fffafa">
          <td class="text-black whitespace-nowrap">FINAL TOTAL :</td>
          <td [attr.colspan]="isGst ? 6 : 3"></td>
          <td class="text-black">₹ {{ summary.closing_balance | number:'1.2-2' }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
<p (click)="openDenomination()"
  class="cursor-pointer underline text-0d5bab font-semibold text-xs sm:text-sm lg:text-base mt-3 text-end">Denominations
</p>

<!-- denominations popup code -->
<!-- Overlay -->
<div *ngIf="showDenominationPopup" (click)="closeDenomination()"
  class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

  <!-- Modal -->
  <div (click)="$event.stopPropagation()"
    class="bg-white rounded-xl w-11/12 sm:w-2/3 lg:w-1/2 2xl:w-2/5 p-4 shadow-xl relative">

    <!-- close button -->
    <button (click)="closeDenomination()"
      class="cursor-pointer absolute top-2 right-2 text-gray-600 hover:text-black text-3xl leading-[0.5]">
      &times;
    </button>

    <!-- Content -->
    <div class="w-full">
      <div class="w-full flex items-center gap-2">
        <!-- card 1 -->
        <div class="bg-f6f7fb rounded-md px-3 lg:px-4 py-2 border-l-4 border-fb7e03">
          <p class="text-[12px] lg:text-[13px] text-1c1c1c font-medium">Opening Balance</p>
          <p class="text-xs lg:text-sm text-fb7e03 font-bold mt-1.5">₹ {{ openingBalance | number:'1.2-2' }}</p>
        </div>

        <!-- card 2 -->
        <div class="bg-f6f7fb rounded-md px-3 lg:px-4 py-2 border-l-4 border-0b9f18">
          <p class="text-[12px] lg:text-[13px] text-1c1c1c font-medium">Amount In</p>
          <p class="text-xs lg:text-sm text-0b9f18 font-bold mt-1.5">₹ {{ summary.amount_in.total | number:'1.2-2' }}
          </p>
        </div>

        <!-- card 3 -->
        <div class="bg-f6f7fb rounded-md px-3 lg:px-4 py-2 border-l-4 border-bb0000">
          <p class="text-[12px] lg:text-[13px] text-1c1c1c font-medium">Amount Out</p>
          <p class="text-xs lg:text-sm text-bb0000 font-bold mt-1.5">₹ {{ summary.amount_out.total | number:'1.2-2' }}
          </p>
        </div>

        <!-- card 4 -->
        <div class="bg-f6f7fb rounded-md px-3 lg:px-4 py-2 border-l-4 border-0d5bab">
          <p class="text-[12px] lg:text-[13px] text-1c1c1c font-medium">Closing Amount</p>
          <p class="text-xs lg:text-sm text-0d5bab font-bold mt-1.5">₹ {{ summary.closing_balance | number:'1.2-2' }}
          </p>
        </div>
      </div>
      <div class="bg-white mt-2 overflow-x-auto w-full">
        <table class="daybook-table w-full overflow-hidden">
          <thead class="text-[13px] sm:text-sm lg:text-[15px] font-semibold">
            <tr class="text-left bg-d9d9d9">
              <th>Denominations</th>
              <th class="text-center">Count</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody class="text-[13px] sm:text-sm lg:text-[15px] font-medium">
            <tr class="border-b border-e9e9e9 last:border-0">
              <td class="text-1c1c1c">₹ 2000</td>
              <td class="text-c19725 text-center">20</td>
              <td class="text-bb0000 text-right">0.00</td>
            </tr>
            <tr class="border-b border-e9e9e9 last:border-0">
              <td class="text-1c1c1c">₹ 2000</td>
              <td class="text-c19725 text-center">20</td>
              <td class="text-bb0000 text-right">0.00</td>
            </tr>
            <tr class="border-b border-e9e9e9 last:border-0">
              <td class="text-1c1c1c">₹ 2000</td>
              <td class="text-c19725 text-center">20</td>
              <td class="text-bb0000 text-right">0.00</td>
            </tr>
            <tr class="border-b border-e9e9e9 last:border-0">
              <td class="text-1c1c1c">₹ 2000</td>
              <td class="text-c19725 text-center">20</td>
              <td class="text-bb0000 text-right">0.00</td>
            </tr>
            <tr class="border-b border-e9e9e9 last:border-0">
              <td class="text-1c1c1c">₹ 2000</td>
              <td class="text-c19725 text-center">20</td>
              <td class="text-bb0000 text-right">0.00</td>
            </tr>
          </tbody>
          <tfoot class="text-[13px] sm:text-sm lg:text-[15px] font-medium">
            <tr class="bg-018f37">
              <td colspan="3" class="text-white text-right">₹ 12,566.00</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>